import React from "react";
import Slider from "react-slick";
import { Center, Stack } from "@chakra-ui/react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { shuffle } from "lodash";
import { Text } from "@chakra-ui/react";

import Quote from "../common/Quote";

const settings = {
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 2000,
  autoplaySpeed: 10000,
  cssEase: "linear",
};

const Testimonials = (props) => {
  const { testimonials, isList } = props;
  if (isList) {
    return (
      <Center>
        <Stack
          minHeight="800px"
          paddingTop="100px"
          w={["75%", "75%", "75%", "50%"]}
        >
          <Text as="i" paddingBottom="50px">
            Disclaimer: The views expressed in these testimonials are those of
            the individuals and do not necessarily reflect the views or
            positions of their affiliated institutions.
          </Text>
          {shuffle(testimonials).map((testimonial) => (
            <Quote
              key={testimonial.name}
              quote={testimonial.quote}
              name={testimonial.name}
              institution={testimonial.institution}
            />
          ))}
        </Stack>
      </Center>
    );
  }

  return (
    <Slider {...settings}>
      {shuffle(testimonials)
        .filter((testimonial) => testimonial.quote.length < 450)
        .map((testimonial) => (
          <Quote
            key={testimonial.name}
            quote={testimonial.quote}
            name={testimonial.name}
            institution={testimonial.institution}
          />
        ))}
    </Slider>
  );
};

export default Testimonials;
